import * as React from "react";
import * as Dtos from "../dtos/Tmd.dtos";

export interface IAuthenticatedUserContext {
    user: Dtos.User;
}

const AuthenticatedUserContext = React.createContext<IAuthenticatedUserContext | undefined>(undefined);

export default AuthenticatedUserContext;
